<script>
  import { useQuery } from "@sveltestack/svelte-query"
  import DialogContent from "../../dialog/DialogContent.svelte";
  import Stack from "../../layout/Stack.svelte";
  import Loading from "../../pages/Loading.svelte";
  import DialogBottomControls from "../../dialog/DialogBottomControls.svelte";
  import DialogBottomControlButton from "../../dialog/DialogBottomControlButton.svelte";
  import { translate } from "../../../i18n/i18next.js";
  import { useProjectUsers } from "../../../hooks/useProjectUsers.js";
  import HelpTooltip from "../../tooltip/HelpTooltip.svelte";

  export let projectId
  export let moveNext = (selectedUser) => {}
  export let closeDialog = () => {}

  const projectUsers = useProjectUsers(projectId)

  let selectedUserId = null
  let searchQuery = ""

  const query = useQuery(
    "/api/users"
  )

  $: users = ($query.data?.users ?? [])
    .filter(user => user.id.includes(searchQuery.toLowerCase()) || user.name.toLowerCase().includes(searchQuery.toLowerCase()))
    .map(user => {
      user.disabled = $projectUsers.findIndex(u => u.id === user.id) !== -1
      return user;
    })
</script>

<DialogContent>
  <Stack direction="vertical" gap=".5rem">
    <span style="font-weight: bold">{translate("frontend:components.restrictedUserInvitationDialog.steps.selectExistingUser.title")}</span>
    <span>
      {translate("frontend:components.restrictedUserInvitationDialog.steps.selectExistingUser.caption")}
    </span>
    <Stack direction="horizontal" gap="1rem">
      <input
        bind:value={searchQuery}
        style="flex-grow: 1"
        placeholder={translate("frontend:pages:projects.project.admin.sections.users.invitationDialog.sections.existingUser.inputPlaceHolder")}
      />
    </Stack>
    <div style="padding: 1rem; border: 1px solid darkgrey; border-radius: 5px">
      <div style="max-height: 500px; height:500px; overflow-y: auto; ">
        <Stack direction="vertical">
          {#if $query.isLoading}
            <Loading height="450px"/>
          {:else}
            {#each users as user}
              <label
                class="option-container"
                class:checked={selectedUserId === user.id}
                class:disabled={user.disabled}>
                <input
                  class="hidden"
                  type="radio"
                  bind:group={selectedUserId}
                  checked={user.id === selectedUserId}
                  disabled={user.disabled}
                  value={user.id}
                />
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="9" stroke="#CCCCCC"/>
                  {#if user.id === selectedUserId}
                    <circle cx="12" cy="12" r="6.5" fill="#00468F"/>
                  {/if}
                </svg>
                <Stack direction="vertical" gap=".5rem">
                  <span class="user-name">
                    {user.name}
                    {#if user.disabled}
                      <HelpTooltip title={translate("frontend:components.restrictedUserInvitationDialog.steps.selectExistingUser.errors.alreadyAdded.title")}>
                        {translate("frontend:components.restrictedUserInvitationDialog.steps.selectExistingUser.errors.alreadyAdded.caption")}
                      </HelpTooltip>
                    {/if}
                  </span>
                  <span style="font-size: .9rem; color: darkgrey">id: {user.id}</span>
                </Stack>
              </label>
            {/each}
          {/if}
        </Stack>
      </div>
    </div>
  </Stack>
</DialogContent>
<DialogBottomControls>
  <DialogBottomControlButton type="primary" disabled={!selectedUserId} onClick={() => moveNext(users.find(user => user.id === selectedUserId))}>
    {translate("generic.next")}
  </DialogBottomControlButton>
  <DialogBottomControlButton type="secondary" onClick={() => closeDialog()}>
    {translate("generic.cancel")}
  </DialogBottomControlButton>
</DialogBottomControls>

<style>
  input {
    width: 100%;
    padding: 0.3em 0.8em;
    border: solid 1px #888888;
    border-radius: 5px;
    outline: none;
  }

  .hidden {
    display: none;
  }

  label {
    cursor: pointer;
  }

  .option-container {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    display: flex;
    align-items: center;
    gap: .5rem;
  }
  .option-container:is(:first-of-type) {
    border-top: 1px solid lightgrey;
  }

  .user-name {
    display: inline-flex;
    gap: .5rem;
  }

  .disabled .user-name {
    color: darkgrey;
    text-decoration: line-through;
  }
</style>
